/* Bobblery — <before-after-slider> custom element.
   Mirrors the range input's value onto a --pos CSS variable that drives
   the clip-path of the "before" overlay and the handle position.
   Progressive enhancement: with no JS the CSS default (--pos: 50%) still
   renders a usable split. */
if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.before-after__range');
        if (!this.range) return;
        this.update = this.update.bind(this);
        this.range.addEventListener('input', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.update);
      }

      update() {
        this.style.setProperty('--pos', `${this.range.value}%`);
      }
    }
  );
}
